import { FunctionComponent } from 'preact';
import './MessageIcon.css';
import { MessageCount } from '../message-count';

export interface MessageIconProps {
  className?: string;
  size?: number;
  color?: string;
  active?: boolean;
  count?: number;
}

export const MessageIcon: FunctionComponent<MessageIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
  active = false,
  count = 0
}) => {
  return (
    <div className="message-icon-container">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={color} 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        class={`message-icon ${active ? 'message-icon--active' : ''} ${className}`}
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      <MessageCount count={count} />
    </div>
  );
};
